export const DEFAULT_SECTION_TITLE = 'Section sans titre';
export const PUT_ON_THE_FRONT_PAGE = 'Mettre à la une';
